<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="CreateInvoice"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :color="$config.invoice.color"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
    @deleted="evh_2248226175642056_deleted($event, {})"
  >
    <UcInvoiceHeader
      :invoice="_.clone(item)"
      :formId="formId"
      :formContext="formContext"
      :invoiceNumber="registerEntry ? item.reference_number : null"
    >
    </UcInvoiceHeader>
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      name="invoice"
      autofocus="first"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <FieldsetInvoiceHeader
        :formId="formId"
        :invoice="item"
        :labelAlign="labelAlign"
      >
      </FieldsetInvoiceHeader>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    :color="$config.invoice.color"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :form="forms.invoice && forms.invoice.id"
      icon="fa-save"
      :text="'Create invoice'|pgettext('CreateInvoice|Submit')"
      type="submit"
      variant="primary"
      :spinning="actions.submit.isRunning"
      :disabled="!forms.invoice || !forms.invoice.submittable"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      :disabled="actions.submit.isRunning"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class CreateInvoice extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
    default: "outgoing",
  })
  invoiceKind!: string;

  @Watch('invoiceKind')
  onInvoice_kind(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoiceKind")
  }

  @Prop({
    type: String,
    default: "normal",
  })
  invoiceType!: string;

  @Watch('invoiceType')
  onInvoice_type(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoiceType")
  }

  @Prop({
    type: String,
  })
  registerEntry!: string;

  @Watch('registerEntry')
  onRegister_entry(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("registerEntry")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  labelAlign!: any;
  titles!: any;
  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  item!: any;

  async $$load_item() {
    return this.$fn.fetch('get_invoice_template', {
      parameters: {
        invoice_kind: this.invoiceKind,
        invoice_type: this.invoiceType,
        register_entry: this.registerEntry
      }
    }).then(data => new this.$fn.Resource(data, {
      billing_period: data.billing_period || { start: null, end: null },
    })
    )
  }

  formContext!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['labelAlign', 'titles', 'formId', 'item', 'formContext', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        labelAlign: "right",
        titles: {
          incoming: this.$fn.pgettext("Invoice", "Create Incoming Invoice"),
          outgoing: this.$fn.pgettext("Invoice", "Create Outgoing Invoice"),
        }
        ,
        formId: null,
        item: null,
        formContext: {
        }
        ,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
      },
    }
  }

  get incomingInvoice() {
    if (this.loaded) {

      return this.invoiceKind === 'incoming'
    }
    return null;
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.titles[this.invoiceKind],
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_3332_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_3332, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_reloadSlickgrid_3338_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_2248226175642056_reloadSlickgrid_3338, alias=undefined
    return {
      grid: "invoices",
    }
  }

  async evh_2248226175642056_deleted(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_deleted.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeModal_3342_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_3342, alias=undefined
    return {
      result: {
        close: true,
      }
      ,
    }
  }

  async act_1040167445267876_navigate_3344_getActionArgs($event: actions.ActionEvent): Promise<actions.NavigateActionArgs> {
    // parameterResolver name=act_1040167445267876_navigate_3344, alias=undefined
    return {
      location: {
        name: "app.invoice",
        params: {
          id: $event.data.id,
        }
        ,
      }
      ,
    }
  }

  async act_1040167445267876_crud_3340_getActionArgs($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_1040167445267876_crud_3340, alias=submit
    return {
      objectType: "invoice",
      op: "upsert",
      data: this.item,
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_1419464017721962_closeModal_3346_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1419464017721962_closeModal_3346, alias=undefined
    return {
      result: {
        close: true,
      }
      ,
    }
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_3332: actions.CloseModalAction;
    evh_7315092382398562_close_3331: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeModal_3334: actions.CloseModalAction;
    evh_2248226175642056_close_3333: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_2248226175642056_closeModal_3336: actions.CloseModalAction;
    evh_2248226175642056_deleted_3335: actions.EventHandlerImpl;
    act_2248226175642056_reloadSlickgrid_3338: actions.ReloadSlickgridAction;
    evh_2248226175642056_deleted_3337: actions.EventHandlerImpl;
    evh_2248226175642056_deleted: actions.EventHandlerGroup;
    act_1040167445267876_closeModal_3342: actions.CloseModalAction;
    evh_1040167445267876_success_3341: actions.EventHandlerImpl;
    act_1040167445267876_navigate_3344: actions.NavigateAction;
    evh_1040167445267876_success_3343: actions.EventHandlerImpl;
    act_1040167445267876_crud_3340: actions.CRUDAction;
    evh_1040167445267876_submit_3339: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeModal_3346: actions.CloseModalAction;
    evh_1419464017721962_clickPreventStop_3345: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_3332 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_3332_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_3331 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_3332,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_3331],
      }
    );
    const act_2248226175642056_closeModal_3334 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_3333 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeModal_3334,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_3333],
      }
    );
    const act_2248226175642056_closeModal_3336 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_deleted_3335 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeModal_3336,
        event: "deleted",
        displayName: "closeModal",
      }
    );
    const act_2248226175642056_reloadSlickgrid_3338 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_2248226175642056_reloadSlickgrid_3338_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_deleted_3337 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_reloadSlickgrid_3338,
        event: "deleted",
        displayName: "reloadSlickgrid",
      }
    );
    const evh_2248226175642056_deleted = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_deleted_3335, evh_2248226175642056_deleted_3337],
      }
    );
    const act_1040167445267876_closeModal_3342 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_3342_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_3341 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_3342,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_navigate_3344 = new actions.NavigateAction(
      {
        actionArgs: this.act_1040167445267876_navigate_3344_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_3343 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_navigate_3344,
        event: "success",
        displayName: "navigate",
      }
    );
    const act_1040167445267876_crud_3340 = new actions.CRUDAction(
      {
        actionArgs: this.act_1040167445267876_crud_3340_getActionArgs,
        displayName: "submit",
        events: [evh_1040167445267876_success_3341, evh_1040167445267876_success_3343],
      }
    );
    const evh_1040167445267876_submit_3339 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_crud_3340,
        event: "submit",
        displayName: "submit",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_3339],
      }
    );
    const act_1419464017721962_closeModal_3346 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1419464017721962_closeModal_3346_getActionArgs,
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_3345 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeModal_3346,
        event: "click.prevent.stop",
        displayName: "closeModal",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_3345],
      }
    );
    return {
      act_7315092382398562_closeModal_3332,
      evh_7315092382398562_close_3331,
      evh_7315092382398562_close,
      act_2248226175642056_closeModal_3334,
      evh_2248226175642056_close_3333,
      evh_2248226175642056_close,
      act_2248226175642056_closeModal_3336,
      evh_2248226175642056_deleted_3335,
      act_2248226175642056_reloadSlickgrid_3338,
      evh_2248226175642056_deleted_3337,
      evh_2248226175642056_deleted,
      act_1040167445267876_closeModal_3342,
      evh_1040167445267876_success_3341,
      act_1040167445267876_navigate_3344,
      evh_1040167445267876_success_3343,
      act_1040167445267876_crud_3340,
      evh_1040167445267876_submit_3339,
      evh_1040167445267876_submit,
      act_1419464017721962_closeModal_3346,
      evh_1419464017721962_clickPreventStop_3345,
      evh_1419464017721962_clickPreventStop,
      submit: act_1040167445267876_crud_3340,
    }
  }
}

Vue.component("CreateInvoice", CreateInvoice);

</script>